import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as ihm from './ihm';

export const mailz = { // icv.mailz と統合用
  lz: {
    grtMsg1: (_dz: {
      i18rz: _ht.dz,
      i1zrz: _ht.dz,
      stgz: _ht.dz,
    }) => {
return (
`団体番号：${_dz.i18rz?.i18rab100s ?? ''}
${_dz.i18rz?._pfx ?? ''}　様

-------------------------------------------------

エントリー抽選結果をご連絡致します。

下記エントリーが当選し、正式な予約として登録致しました。

<<< エントリー内容 >>>　　(ID：${_dz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${_hmDTM.f(_dz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${_dz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${_dz.i1zrz?.i1zra1200s ?? ''}
${_dz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${_dz.i1zrz?.i1zra8100s}` : ''}

-------------------------------------------------
${_dz.stgz?.S08050111 ?? ''}


${_dz.stgz?.S01050111 ?? ''}
`
)},
    grtMsg2: (_dz: {
      i18rz: _ht.dz,
      i1zrz: _ht.dz,
      stgz: _ht.dz,
    }) => {
return (
`団体番号：${_dz.i18rz?.i18rab100s ?? ''}
${_dz.i18rz?._pfx ?? ''}　様

-------------------------------------------------

エントリー抽選結果をご連絡致します。

下記エントリーが当選し、正式な予約として登録致しました。

なお、お申し込みいただいた備品・駐車場の一部は、
抽選の結果、ご利用対象から除外しておりますので、
ご了承ください。

<<< エントリー内容 >>>　　(ID：${_dz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${_hmDTM.f(_dz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${_dz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${_dz.i1zrz?.i1zra1200s ?? ''}
${_dz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${_dz.i1zrz?.i1zra8100s}` : ''}

-------------------------------------------------
${_dz.stgz?.S08050111 ?? ''}


${_dz.stgz?.S01050111 ?? ''}
`
)},
    grtMsg3: (_dz: {
      i18rz: _ht.dz,
      i1zrz: _ht.dz,
      stgz: _ht.dz,
    }) => {
return (
`団体番号：${_dz.i18rz?.i18rab100s ?? ''}
${_dz.i18rz?._pfx ?? ''}　様

-------------------------------------------------

エントリー抽選結果をご連絡致します。

下記エントリーについて抽選の結果、
残念ながら今回はご期待に沿えない結果となりました。

<<< エントリー内容 >>>　　(ID：${_dz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${_hmDTM.f(_dz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${_dz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${_dz.i1zrz?.i1zra1200s ?? ''}
${_dz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${_dz.i1zrz?.i1zra8100s}` : ''}

-------------------------------------------------
${_dz.stgz?.S08050121 ?? ''}


${_dz.stgz?.S01050111 ?? ''}
`
)},

    grtMailEtlErr1: (pz: {
      _31rz: _ht.dz,
      i1zrz: _ht.dz,
      iptz: _ht.dz,
      optz: _ht.dz,
    }) => { // 外部連携エラー
      const _31r_pfx = pz._31rz?._pfx ?? ''
      return {
        sjt:
`外部連携の際にエラーが発生しました（${_31r_pfx}）`,
        msg:
`
${_31r_pfx}　ご担当者　様
-----------------------------------------------------
何らかの原因により市システムへの更新が失敗致しました。
ご確認をお願いいたします。
(市システムの応答：${pz.optz?.data ?? ''})
-----------------------------------------------------
予約ID：${pz.i1zrz?._icn ?? ''}
利用施設：${_31r_pfx ?? ''}
利用日：${pz.iptz?.date ?? ''}
利用団体：${pz.iptz?.dname ?? ''}
部屋名：${pz.i1zrz?.i1zra1100s ?? ''}
利用時間：${pz.iptz?.start ?? ''}〜${pz.iptz?.end ?? ''}
減免：${ihm.cvtGenmenflgNbrToSrg(pz.iptz?.genmenflg)}
予約種別：${ihm.cvtYflgNbrToSrg(pz.iptz?.yflg)}
料金(減免前)：${_hm.n(pz.iptz?.ryokin)}
減免額：${_hm.n(pz.iptz?.genmenFee)}
支払額：${_hm.n(pz.iptz?.ryokin) - _hm.n(pz.iptz?.genmenFee)}
備考：${pz.iptz?.bikou ?? ''}
`,
      }
    },

    grtMailEtlErr2: (pz: {
      _31rz: _ht.dz,
      i1zrz: _ht.dz,
      iptz: _ht.dz,
      optz: _ht.dz,
    }) => { // 外部連携エラー
      const _31r_pfx = pz._31rz?._pfx ?? ''
      return {
        sjt:
`外部連携の際にエラーが発生しました（${_31r_pfx}）`,
        msg:
`
${_31r_pfx}　ご担当者　様
-----------------------------------------------------
市システム上に競合する予約が登録されている為、連携に失敗しました。
市システムを確認し、競合する予約の削除をお願いします。
競合する予約を削除後、Fサポート上で予約を更新すると再度連携処理を実施します。
(市システムの応答：${pz.optz?.data ?? ''})
-----------------------------------------------------
予約ID：${pz.i1zrz?._icn ?? ''}
利用施設：${_31r_pfx ?? ''}
利用日：${pz.iptz?.date ?? ''}
利用団体：${pz.iptz?.dname ?? ''}
部屋名：${pz.i1zrz?.i1zra1100s ?? ''}
利用時間：${pz.iptz?.start ?? ''}〜${pz.iptz?.end ?? ''}
減免：${ihm.cvtGenmenflgNbrToSrg(pz.iptz?.genmenflg)}
予約種別：${ihm.cvtYflgNbrToSrg(pz.iptz?.yflg)}
料金(減免前)：${_hm.n(pz.iptz?.ryokin)}
減免額：${_hm.n(pz.iptz?.genmenFee)}
支払額：${_hm.n(pz.iptz?.ryokin) - _hm.n(pz.iptz?.genmenFee)}
備考：${pz.iptz?.bikou ?? ''}
`,
      }
    },

    grtMailArsAdd: (pz: {
      i18rz: _ht.dz,
    }) => { // メールアドレスの登録
      return {
        sjt:
`メールアドレス登録のご連絡`,
        msg:
`
この度は、メールアドレスのご登録をありがとうございます。
登録されたアドレスをご連絡します。

<<< 登録されたメールアドレス >>>

${pz.i18rz.i18ra4110s ? `　主　： ${pz.i18rz.i18ra4110s}` : ''}
${pz.i18rz.i18ra4210s ? `　副１： ${pz.i18rz.i18ra4210s}` : ''}
${pz.i18rz.i18ra4310s ? `　副２： ${pz.i18rz.i18ra4310s}` : ''}
`,
      }
    },

    grtMailRsvAdd: (pz: { // reserve add
      i1zrz: _ht.dz,
    }) => {
      return {
        sjt:
`ご予約を受け付けました（ID：${pz.i1zrz?._icn ?? ''}）`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

下記ご予約を受け付けましたので、ご連絡いたします。
なお、本ご予約を変更する場合は、キャンセルした後、改めてご予約ください。

<<< ご予約内容 >>>　　(ID：${pz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${_hmDTM.f(pz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${pz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${pz.i1zrz?.i1zra1200s ?? ''}
${pz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${pz.i1zrz?.i1zra8100s}` : ''}
`
}},

    grtMailRsvCcl: (pz: { // reserve cancel
      i1zrz: _ht.dz,
    }) => {
      return {
        sjt:
`ご予約のキャンセルを受け付けました（ID：${pz.i1zrz?._icn ?? ''}）`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

下記ご予約のキャンセルを受け付けましたので、ご連絡いたします。

<<< ご予約内容 >>>　　(ID：${pz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${_hmDTM.f(pz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${pz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${pz.i1zrz?.i1zra1200s ?? ''}
${pz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${pz.i1zrz?.i1zra8100s}` : ''}
`
    }},

    grtMailAlyAdd: (pz: { // Apply add
      i1zrz: _ht.dz,
    }) => {
      return {
        sjt:
`エントリーを受け付けました（ID：${pz.i1zrz?._icn ?? ''}）`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

下記エントリーを受け付けましたので、ご連絡いたします。
なお、本エントリーを変更する場合は、キャンセルした後、改めてご予約ください。

<<< エントリー内容 >>>　　(ID：${pz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${_hmDTM.f(pz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${pz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${pz.i1zrz?.i1zra1200s ?? ''}
${pz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${pz.i1zrz?.i1zra8100s}` : ''}
`
}},

    grtMailAlyCcl: (pz: { // reserve cancel
      i1zrz: _ht.dz,
    }) => {
      return {
        sjt:
`エントリーのキャンセルを受け付けました（ID：${pz.i1zrz?._icn ?? ''}）`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

下記エントリーのキャンセルを受け付けましたので、ご連絡いたします。

<<< エントリー内容 >>>　　(ID：${pz.i1zrz?._icn ?? ''})

■ 利用日　　 ： ${_hmDTM.f(pz.i1zrz?.i1zrd3100s ?? '', '年月日（曜）')}
■ 部屋　　　 ： ${pz.i1zrz?.i1zra1100s ?? ''}
■ 利用時間帯 ： ${pz.i1zrz?.i1zra1200s ?? ''}
${pz.i1zrz?.i1zra8100s ? `■ 伝達事項　 ： ${pz.i1zrz?.i1zra8100s}` : ''}
`
    }},

    grtMailSendPwd: (pz: { // send password
      i18rz: _ht.dz,
    }) => {
      return {
        sjt:
`パスワードをお知らせします`,
        msg: 
`
ご利用いただきまして誠にありがとうございます。

ログイン画面において別途ご入力いただいたログインIDのパスワードは以下のとおりです。

<<< 別途ご入力いただいたログインIDのパスワード >>>

${pz.i18rz.i18ra4130s}
`
    }},
  }
}

export const otrz = {
  key: -999,
  pfx: 'その他1時間',
  _fst: -999,
  _pfx: 'その他1時間', // i1z1a2200s の設定に必要
  cldz: {},
}; // その他１時間
